import { defineMessages } from 'react-intl';

type ProductTileMessagesType = {
    servicesCaptionMessage: { defaultMessage: string };
    servicesLinkTextJS: { defaultMessage: string };
    servicesLinkTextMD: { defaultMessage: string };
    overlayTitleJS: { defaultMessage: string };
    overlayTitleMD: { defaultMessage: string };
    a11YCloseServicesMessage: { defaultMessage: string };
    learnMore: { defaultMessage: string };
    onlineExperienceLocation: {
        defaultMessage: string;
    };
    multipleLocations: {
        defaultMessage: string;
    };
    participantsLabel: {
        defaultMessage: string;
    };
    bookAppointment: {
        defaultMessage: string;
    };
    screenReaderTextForWishlistRemove: {
        defaultMessage: string;
    };
    screenReaderTextForWishlistAdd: {
        defaultMessage: string;
    };
    tooManyWishlistArticlesError: {
        defaultMessage: string;
    };
    a11yCloseErrorMessage: {
        defaultMessage: string;
    };
    closePopup: { defaultMessage: string };
    pricePrefix: { defaultMessage: string };
    activityDurationMaxPrefix: { defaultMessage: string };
    activityDurationDay: { defaultMessage: string };
    activityDurationDays: { defaultMessage: string };
    activityDurationHours: { defaultMessage: string };
    activityDurationMinutes: { defaultMessage: string };
    travelNight: { defaultMessage: string };
    travelNights: { defaultMessage: string };
    valueVoucherProductInfoFlexible: { defaultMessage: string };
    valueVoucherProductInfoDelivery: { defaultMessage: string };
    valueVoucherProductInfoGiftWrap: { defaultMessage: string };
};

const messages = defineMessages({
    servicesCaptionMessage: { defaultMessage: 'Details' },
    servicesLinkTextJS: { defaultMessage: '+ Was erwartet dich?' },
    servicesLinkTextMD: { defaultMessage: '+ Was erwartet Dich?' },
    overlayTitleJS: { defaultMessage: 'Was erwartet dich?' },
    overlayTitleMD: { defaultMessage: 'Was erwartet Dich?' },
    a11YCloseServicesMessage: { defaultMessage: 'Leistungsbeschreibung schließen' },
    learnMore: { defaultMessage: 'Mehr erfahren' },
    onlineExperienceLocation: { defaultMessage: 'Online-Erlebnis' },
    multipleLocations: { defaultMessage: 'an {locationCount} Orten' },
    participantsLabel: { defaultMessage: '{participants} Pers.' },
    bookAppointment: { defaultMessage: 'Termin buchen' },
    screenReaderTextForWishlistRemove: { defaultMessage: 'Von der Wunschliste entfernen' },
    screenReaderTextForWishlistAdd: { defaultMessage: 'Zur Wunschliste hinzufügen' },
    tooManyWishlistArticlesError: {
        defaultMessage:
            'Die maximale Anzahl an Erlebnissen wurde erreicht – bitte entferne Artikel, um Platz für neue zu schaffen.',
    },
    a11yCloseErrorMessage: { defaultMessage: 'Schließen' },
    closePopup: { defaultMessage: 'Popup Schließen' },
    pricePrefix: { defaultMessage: 'ab' },
    activityDurationMaxPrefix: { defaultMessage: 'max.' },
    activityDurationDay: { defaultMessage: 'Tag' },
    activityDurationDays: { defaultMessage: 'Tage' },
    activityDurationHours: { defaultMessage: 'Std' },
    activityDurationMinutes: { defaultMessage: 'Min' },
    travelNight: { defaultMessage: 'Nacht' },
    travelNights: { defaultMessage: 'Nächte' },
    valueVoucherProductInfoFlexible: {
        defaultMessage: 'ab 20 {currencySymbol} flexibel wählbar',
    },
    valueVoucherProductInfoDelivery: { defaultMessage: 'per Post oder PDF' },
    valueVoucherProductInfoGiftWrap: { defaultMessage: 'wahlweise mit Geschenkverpackung' },
});

const getProductTileMessages = (): ProductTileMessagesType => messages;

export { getProductTileMessages, type ProductTileMessagesType };
